import { useState } from 'react'
import ReactDOM from "react-dom";
import { useDispatch, useSelector } from 'react-redux';

import Backdrop from "../../common/modal/Backdrop";
import Modal from "../../common/Modal";
import Button from "../../common/Button";
import GetInTouchBox from "../../fragments/GetInTouchBox";
import CopyText from "../../fragments/CopyText";
import AddNotes from "../details/notes/AddNotes";
import PhoneNumber from "../../common/PhoneNumber";
import ClearDataTest from "./ClearDataTest";
import { detailsActions } from '../../../store/details';

import classes from './PatientDetailsControls.module.css'
import { alertsButtonColor, flagsButtonColor, isDeveloper, isDeveloperOrMoonBird, notesButtonColor } from '../../../lib/script';
import BodySimpleModalV3 from '../../common/modal/BodySimpleModalV3';
import { useUserTabEditPermissionDisabled } from '../../../lib/usersPermissions';
import SyncEntireCase from './SyncEntireCase';
import { practicesFunctions } from '../../../lib/practices';

const PatientDetailsControls = ({hasClear, detailsExtraControls}) => {
    const dispatch = useDispatch()

    const activeCase = useSelector(state => state.case.activeCase)
    let historyPermission = useUserTabEditPermissionDisabled('history_view')

    const [isModalOpened, setisModalOpened] = useState(false)

    const openModalHandler = () => {
        setisModalOpened(true)
    }

    const closeModalHandler = () => {
        setisModalOpened(false)
    }

    function goToNotesTab() {
        dispatch(detailsActions.setActiveTab(12))
    }

    function goToFlagsTab() {
        dispatch(detailsActions.setActiveTab(26))
    }

    function goToAlertsTab() {
        dispatch(detailsActions.setActiveTab(36))
    }    

    function goToHistoryTab() {
        dispatch(detailsActions.setActiveTab(27))
    }

    return <div className={classes.controls_container}>       
        {activeCase && <>
            {/* <button
                onClick={() => {
                    throw new Error('This is your first error!');
                }}
                >
                Break the world
            </button> */}

            {practicesFunctions.getAICAChartNumber(activeCase) && <div className={classes.copy_text_box}><CopyText text={practicesFunctions.getAICAChartNumber(activeCase)} prefix={'AICA #'}/></div>}
            {activeCase.patient && activeCase.patient.person_number && <div className={classes.copy_text_box}><CopyText text={activeCase.patient.person_number} prefix={'NG #'}/></div>}

            {activeCase.patient && activeCase.patient.contact_information && <>            
                {activeCase.patient.contact_information?.email && <BodySimpleModalV3 message={'Send Email'} widthAuto={true}>
                    <GetInTouchBox goto={activeCase.patient.contact_information.email} boxType={'mailto'} activeCase={activeCase.patient} type={'Patient'}/>
                </BodySimpleModalV3> } 

                {/* {activeCase.patient.contact_information?.phone && <BodySimpleModalV3 message={'Send SMS'} widthAuto={true}>
                    <GetInTouchBox goto={activeCase.patient.contact_information.cell_phone} boxType={'sms'} activeCase={activeCase.patient} type={'Patient'}/>
                </BodySimpleModalV3>} */}

                {activeCase.patient.contact_information?.cell_phone && <BodySimpleModalV3 message={'Cell Phone'} widthAuto={true}>
                    <PhoneNumber value={activeCase.patient.contact_information?.cell_phone} isMobile={true}/>    
                </BodySimpleModalV3>}

                {activeCase.patient.contact_information?.phone && <BodySimpleModalV3 message={'Day Phone'} widthAuto={true}>
                    <PhoneNumber value={activeCase.patient.contact_information.phone} ext={activeCase.patient.contact_information.phone_ext}/>    
                </BodySimpleModalV3>}

                {activeCase.patient.contact_information?.phone_2 && <BodySimpleModalV3 message={'Home Phone'} widthAuto={true}>
                    <PhoneNumber value={activeCase.patient.contact_information.phone_2} />    
                </BodySimpleModalV3>}              

                
            </>}
        </>}

        

        {/* <Button click={openModalHandler} title={'add new note'} square={true}>
            <i className='ti ti-square-plus'></i>
            <span className="sr-only">add new note</span>
        </Button> */}

        {detailsExtraControls && activeCase && <>
            {historyPermission && <BodySimpleModalV3 message={'View History'} widthAuto={true}>
                <Button click={goToHistoryTab} square={true} bypassisCaseArchived={true}>
                    <i className='ti ti-history'></i>
                </Button>
            </BodySimpleModalV3>}
            
            <BodySimpleModalV3 message={'View Notes / Tasks'} widthAuto={true}>
                <Button click={goToNotesTab} square={true} btnStyle={notesButtonColor(activeCase?.notes)} bypassisCaseArchived={true}>
                    <i className='ti ti-clipboard-list'></i>
                </Button>
            </BodySimpleModalV3>
            
            <BodySimpleModalV3 message={'View Flags'} widthAuto={true}>
                <Button click={goToFlagsTab} square={true} btnStyle={flagsButtonColor(activeCase?.case_flag)} bypassisCaseArchived={true}>
                    <i className='ti ti-flag-share'></i>
                </Button>
            </BodySimpleModalV3>
            
            <BodySimpleModalV3 message={'View Alerts'} widthAuto={true}>
                <Button click={goToAlertsTab} square={true} btnStyle={alertsButtonColor(activeCase?.case_alerts)} bypassisCaseArchived={true}>
                    <i className='ti ti-bell'></i>
                    {activeCase?.case_alerts && activeCase?.case_alerts.length > 0 && 
                        <span className={classes.badge}>{activeCase?.case_alerts.length} {activeCase?.case_alerts.length == 1 ? 'Alert!' : 'Alerts!'}</span>
                    }
                </Button>
            </BodySimpleModalV3>    
        </>}

        {/* for test only  */}
        {hasClear && isDeveloperOrMoonBird() && <BodySimpleModalV3 message={'Clear Data'} widthAuto={true}>
            <ClearDataTest />    
        </BodySimpleModalV3>} 
        {/* for test only  */}

        {/* {isDeveloperOrMoonBird() && <SyncEntireCase />} */}
        <SyncEntireCase />

        {isModalOpened && <>
            {ReactDOM.createPortal(
                <Backdrop hide={closeModalHandler} noBlur />,
                document.getElementById("backdrop-root")
            )}  
            {ReactDOM.createPortal(
                <Modal>
                    <AddNotes closeModal={closeModalHandler}/>
                </Modal>,
                document.getElementById("overlay-root")
            )}          
        </>}
    </div>

}

export default PatientDetailsControls